var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8901 18.208L23.0142 33.9519C23.45 34.5177 24.3137 34.4855 24.7058 33.8882L44.8945 3.1564C45.5787 2.11488 44.1838 0.971012 43.2967 1.84616L23.3918 21.4797L12.1252 16.6194C11.1408 16.1947 10.2365 17.3581 10.8905 18.2072L10.8901 18.208Z",
    fill: "#5EB5AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 45.7206C16.9311 45.7206 11.2255 43.3573 6.93412 39.0659C2.6427 34.7745 0.279449 29.069 0.279449 23C0.279449 16.9311 2.6427 11.2256 6.93412 6.93415C11.2255 2.64273 16.9311 0.27948 23 0.27948C26.5163 0.27948 29.8877 1.06148 33.0215 2.60363C34.0047 3.08778 34.4095 4.27726 33.9258 5.26051C33.4416 6.24415 32.2521 6.64856 31.2689 6.1648C28.6852 4.89328 25.9034 4.24851 23.0004 4.24851C17.9917 4.24851 13.2829 6.19891 9.74088 9.74091C6.19927 13.2825 4.24848 17.9914 4.24848 23.0004C4.24848 28.0094 6.19888 32.7179 9.74088 36.2599C13.2825 39.8015 17.9914 41.7523 23.0004 41.7523C28.0094 41.7523 32.7179 39.8019 36.2599 36.2599C39.8015 32.7183 41.7523 28.0094 41.7523 23.0004C41.7523 21.4529 41.5637 19.9146 41.1915 18.4284C40.925 17.365 41.5713 16.2875 42.6343 16.0214C43.6977 15.755 44.7752 16.4013 45.0413 17.4643C45.4925 19.2656 45.7209 21.1282 45.7209 23.0004C45.7209 29.0693 43.3577 34.7749 39.0663 39.0663C34.7748 43.3577 29.0693 45.721 23.0004 45.721L23 45.7206Z",
    fill: "#5EB5AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon1);
export default __webpack_public_path__ + "static/media/tick_icon 1.8c626b9f64f1014c6fe732507ecea79c.svg";
export { ForwardRef as ReactComponent };